import request from '@/utils/request'

export function saveArea(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityArea.saveArea',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '保存社区失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function updateArea(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityArea.updateArea',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '更新社区失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function deleteArea(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityArea.deleteArea',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除社区失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function listAreas(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityArea.listAreas',
      method: 'get',
      params: {
        ...params,
        page: params.page - 1
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function saveAreaCommunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityArea.saveAreaCommunity',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '绑定小区失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function deleteAreaCommunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityArea.deleteAreaCommunity',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '解绑小区失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function listAreaCommunities(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityArea.listAreaCommunities',
      method: 'get',
      params: {
        ...params,
        page: params.page - 1
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function saveAreaStaff(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityArea.saveAreaStaff',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '绑定人员失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function deleteAreaStaff(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityArea.deleteAreaStaff',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '解绑人员失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function listAreaStaffs(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityArea.listAreaStaffs',
      method: 'get',
      params: {
        ...params,
        page: params.page - 1
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
